/**
 * @author Artem Lytvynov
 * @copyright Artem Lytvynov
 * @license Apache-2.0
 */

export enum CONNECTIVE_OP_VALUES {
  NONE = "none",
  OR = "or",
  AND = "and",
}
